import { DropDownList, DropDownListChangeEvent } from '@progress/kendo-react-dropdowns';
import { InvoiceStatus } from 'enums';
import styles from './InvoiceStatusFilter.module.scss';
import { DropDownButton } from 'components/Buttons/DropDownButton/DropDownButton';

const options = ['All', InvoiceStatus.Paid, InvoiceStatus.ScheduledToPay, InvoiceStatus.PaymentInReview, InvoiceStatus.PaymentOnHold];

type Props = {
    status: InvoiceStatus | undefined,
    onStatusChange: (value: InvoiceStatus) => void
};

const InvoiceStatusFilter = ({ status, onStatusChange }: Props) => (
    <DropDownButton
        items={options}
        text={` Status: ${status ?? 'All' } `}
        onItemClick={(e) => onStatusChange(e.item === 'All' ? undefined : e.item)}
        size={'small'}
        fillMode={'solid'}
        rounded={'small'}
        tabIndex={0}
    />
);
export default InvoiceStatusFilter;